import axios from 'axios'
import localforage from 'localforage'

const RESOURCE_NAME = '/offers'

export default {
  getChartStatsGeneral () {
    return axios.get(`/charts/stats-general`)
  },
  getAll (params) {
    let apiParams = new URLSearchParams(window.location.search).toString()
    if (params) {
      apiParams = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&')
    }
    if (apiParams) {
      return axios.get(`${RESOURCE_NAME}?${apiParams.toString()}`)
    } else {
      return axios.get(`${RESOURCE_NAME}`)
    }
  },

  getAllSync () {
    return axios.get(`${RESOURCE_NAME}?per_page=-1`)
  },

  get (id) {
    if (navigator.onLine) {
      return axios.get(`${RESOURCE_NAME}/${id}`)
    } else {
      return this.getOfflineDataById(id)
    }
  },

  getUserOffers (id) {
    return axios.get(`${RESOURCE_NAME}/get-clients-offers/${id}`)
  },

  create (data) {
    return axios.post(RESOURCE_NAME, data)
  },

  update (id, data) {
    return axios.put(`${RESOURCE_NAME}/${id}`, data)
  },

  delete (id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`)
  },
  previewOffer (data) {
    return axios.post(`${RESOURCE_NAME}/preview`, data)
  },
  sendOffer (data) {
    return axios.post(`${RESOURCE_NAME}/send-to-client`, data)
  },

  getOfflineData () {
    let urlParams = new URLSearchParams(window.location.search)
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      let templates = {
        data: {
          data: [],
          meta: {}
        }
      }
      // templates.data.data = localforage.getItem('templates')
      localforage.getItem('templates').then((response) => {
        let perPage = urlParams.get('per_page') ? urlParams.get('per_page') : 25
        let page = urlParams.get('page') ? urlParams.get('page') : 1
        page = page - 1
        let start = page * perPage
        let stop = parseInt(start, 10) + parseInt(perPage, 10)
        // SEARCH
        if (urlParams.get('q')) {
          let search = urlParams.get('q').toLowerCase()
          response = response.filter(function (data) {
            // return data
            if (data.name && data.name.toLowerCase().includes(search)) {
              return data
            }
            if (data.content && data.content.toLowerCase().includes(search)) {
              return data
            }
          })
        }
        // SORT
        // let sortBy = urlParams.get('sort_by') ? urlParams.get('sort_by') : null
        // let sortType = urlParams.get('sort_type') ? urlParams.get('sort_type') : 1
        // sortType = sortType === 'ASC' ? 1 : -1
        // if (sortBy) {
        //   if (sortBy === 'city' || sortBy === 'county') {
        //     // response.sort((a, b) => (a.sortBy > b.sortBy) ? 1 * sortType : (-1) * sortType)
        //     response.sort(function (a, b) {
        //       let sortA = a.sortBy != null ? a.sortBy.name : null
        //       let sortB = b.sortBy != null ? b.sortBy.name : null
        //       return (sortA < sortB) ? 1 * sortType : (-1) * sortType
        //     })
        //   } else {
        //     response.sort((a, b) => (a.sortBy > b.sortBy) ? 1 * sortType : (-1) * sortType)
        //   }
        // }
        // end SORT
        let total = response.length
        templates.data.data = response.slice(start, stop)
        templates.data.meta = {
          current_page: page + 1,
          from: start,
          last_page: Math.ceil(total / perPage),
          per_page: perPage,
          to: stop,
          total: total
        }
        resolve(templates)
      })
    })
  },

  getOfflineDataById (id) {
    return new Promise((resolve, reject) => { // The Promise used for router redirect in login
      let template = {
        data: {
          data: null
        }
      }
      // clients.data.data = localforage.getItem('clients')
      localforage.getItem('templates').then((response) => {
        template.data.data = response.find(x => x.id === id)
        resolve(template)
      })
    })
  },
  searchInOffers (val) {
    return axios.get(`${RESOURCE_NAME}/search-in/${val}`)
  }
}
